<template>
  <div class="network-image-input">
    <el-input placeholder="请输入网络路径" :value="url" @input="handleInput"/>
    <img v-if="url !== ''" :src="url"/>
  </div>
</template>

<script>
export default {
  name: 'NetworkImageInput',
  data () {
    return {
      url: ''
    }
  },
  methods: {
    handleInput (value) {
      this.url = value
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss">
.network-image-input {
  img {
    margin-top: 10px;
    width: 100%;
    height: 180px;
    object-fit: contain;
  }
}
</style>
